const FJKeymap = (function () {
    const DEFAULT_SCOPE = 'default';
    let _scope = DEFAULT_SCOPE;
    let _target = null;

    return {
        /**
         * @description 绑定键盘事件
         * @param {number} keycode 键盘keycode https://segmentfault.com/a/1190000005828048
         * @param {function} handler 回调函数
         * @param {object} options
         * @param {string} options.scope 作用空间
         * @returns
         */
        keymap: function (keycode, handler, options = { scope: DEFAULT_SCOPE }) {
            const { scope } = options;
            const func = event => {
                if (
                    (_scope === 'previewModalVideo' || _scope === 'stockVideo' || _scope === 'templateDetailVideo') &&
                    event.keyCode === 32
                ) {
                    event.preventDefault();
                }
                if (_scope === scope && event.keyCode === keycode) {
                    handler(event);
                }
            };
            _target = _target || document;
            _target.addEventListener('keydown', func);

            return () => {
                _target.removeEventListener('keydown', func);
            };
        },

        /**
         * @description 设置作用空间
         * @param {string} scope
         */
        setScope: function (scope) {
            _scope = scope;
        },

        /**
         * @description 返回作用空间
         * @returns {string}
         */
        getScope: function () {
            return _scope;
        },
    };
})();

export default FJKeymap;
